import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Processing from "../pages/processing/page";
import Contact from "../pages/contact/page";
import Imprint from "../pages/imprint/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "processing",
        element: <Processing />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "imprint",
        element: <Imprint />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;